import { ComputedRef, InjectionKey } from "vue";
import { SSOConfig } from "@telegraphio/bapi-types";

/**
 * Vue injection key symbols for provide/inject pattern.
 * Add all new injection keys to this file for centralized management.
 */

export const SSO_CONFIG_KEY: InjectionKey<SSOConfig> = Symbol("SSO_CONFIG");

export const USER_INJECTION_KEY: InjectionKey<string | undefined> = Symbol("USER_ID");

export const TABLE_COLUMN_COUNT_KEY: InjectionKey<number> = Symbol("TABLE_COLUMN_COUNT");

export const TABLE_IS_FETCHING_KEY: InjectionKey<ComputedRef<boolean>> = Symbol("TABLE_IS_FETCHING");

export const SEARCH_WAYBILL_KEY: InjectionKey<(equipmentId: string) => Promise<boolean>> = Symbol("SEARCH_WAYBILL");
